<template>
    <div class="parent">
      <div class="div1">
        <img src="../assets/duraphat/Logo_3.png" alt="Imagen de prueba" />
      </div>
  
      <div class="imagen-centrada">
        <img src="../assets/duraphat/Duraphat.png" alt="Imagen centrada" class="animacion-respiro" />
      </div>
  
      <div class="imagen-derecha">
        <img src="../assets/duraphat/Banner 2.png" alt="Imagen derecha" />
      </div>
  
      <div class="imagen-izquierda">
        <img src="../assets/duraphat/Banner 1.png" alt="Imagen izquierda" />
      </div>
  
      <div class="imagen-superior">
        <img src="../assets/duraphat/Texto_1.png" alt="Imagen superior" />
      </div>
  
      <div class="imagen-inferior">
        <img src="../assets/duraphat/QRP.png" alt="Imagen inferior" />
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResponsiveGrid'
  }
  </script>
  
  <style scoped>
  @keyframes respiro {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }
  
  /* Animación de respiro */
  .animacion-respiro {
    animation: respiro 10s ease-in-out infinite;
  }
  
  .parent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(12, 1fr);
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: url('../assets/duraphat/Fondo_3.png') no-repeat center center;
    background-size: cover;
    position: relative;
  }
  
  /* Contenedor 1 */
  .div1 {
    grid-area: 1 / 1 / 2 / 4;
    min-height: auto;
    box-sizing: border-box;
    transform: translate(15%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
  }
  
  .div1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Imagen centrada */
  .imagen-centrada {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .imagen-centrada img {
    width: 750px;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen centrada verticalmente al lado derecho con aún más separación */
  .imagen-derecha {
    position: absolute;
    top: 50%;
    right: 120px; /* Mayor separación del borde */
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .imagen-derecha img {
    width: 250px;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen centrada verticalmente al lado izquierdo con aún más separación */
  .imagen-izquierda {
    position: absolute;
    top: 50%;
    left: 120px; /* Mayor separación del borde */
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .imagen-izquierda img {
    width: 250px;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen centrada en la parte superior */
  .imagen-superior {
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .imagen-superior img {
    width: 400px;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen centrada en la parte inferior con tamaño reducido a 188px */
  .imagen-inferior {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .imagen-inferior img {
    width: 188px;
    height: auto;
    object-fit: contain;
  }
  
  @media (max-width: 1024px) {
    .imagen-centrada img {
      width: 600px;
    }
  
    .imagen-derecha {
      right: 80px; /* Más separación en tablets */
    }
  
    .imagen-izquierda {
      left: 80px; /* Más separación en tablets */
    }
  
    .imagen-derecha img,
    .imagen-izquierda img {
      width: 200px;
    }
  
    .imagen-superior img {
      width: 350px;
    }
  
    .imagen-inferior img {
      width: 188px;
    }
  }
  
  @media (max-width: 768px) {
    .imagen-centrada img {
      width: 450px;
    }
  
    .imagen-derecha {
      right: 50px; /* Más separación en móviles */
    }
  
    .imagen-izquierda {
      left: 50px; /* Más separación en móviles */
    }
  
    .imagen-derecha img,
    .imagen-izquierda img {
      width: 180px;
    }
  
    .imagen-superior img {
      width: 300px;
    }
  
    .imagen-inferior img {
      width: 188px;
    }
  }
  </style>
  